module.exports = __webpack_public_path__ + "static/img/5.2e49d07.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/9/eng/5.png
// module id = QG9I
// module chunks = 0